import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchMessagesIcon } from 'components/atoms/icons/search-icon';

import s from './styles.module.scss';

const Empty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={s.wrapper}>
      <i>
        <SearchMessagesIcon />
      </i>
      <span>{t('messages.emptySearchResult2')}</span>
    </div>
  );
};

export default Empty;
